import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GeoDifficulty } from "@/lib/types";
import { GEO_DIFFICULTY_LEVELS } from "@/data/geo-constants";

type GeoDifficultySelectProps = {
  value: GeoDifficulty | "";
  onChange: (value: GeoDifficulty) => void;
};

export function GeoDifficultySelect({ value, onChange }: GeoDifficultySelectProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-background/50 border-border/30">
        <SelectValue placeholder="Select difficulty" />
      </SelectTrigger>
      <SelectContent>
        {GEO_DIFFICULTY_LEVELS.map((level) => (
          <SelectItem key={level.value} value={level.value}>
            <div className="flex flex-col">
              <span>{level.label}</span>
              <span className="text-xs text-muted-foreground">{level.description}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
